import React from 'react';
import {
  Table, Divider, Button, Tooltip,
} from 'antd';
import PropTypes from 'prop-types';
import {
  // eslint-disable-next-line no-unused-vars
  EyeOutlined, BuildOutlined, DeleteOutlined, EditOutlined
} from '@ant-design/icons';
import TableWrapper from 'styles/TableWrapper';

const { Column } = Table;

const RecipesTable = (props) => {
  const {
    recipes, history: { replace, push }, deleteSelectedRecipe, handleGenerateSpecification
  } = props;

  const showDeTails = (id) => {
    replace(`/recipe/${id}/details`);
  };

  const handleCDCClick = (recipe, id) => {
    push(`/specification/${recipe.id}/${id}/details`);
  };

  // eslint-disable-next-line no-unused-vars
  const handleEditRecipe = (id) => {
    push(`/recipe/${id}/edit`);
  };

  const getRecipeSpecifications = (record) => (
    <ul>
      {record?.requirements?.items.map(specification => (
        <li>
          <Button type="link" onClick={() => handleCDCClick(record, specification.id)}>{specification.name || 'Sans nom'}</Button>
        </li>
      ))}
    </ul>
  );

  return (
    <TableWrapper>
      <Table dataSource={recipes} scroll={{ x: true }}>
        <Column title="Nom" dataIndex="name" key="name" />
        <Column
          title="Cahiers des charges"
          key="specification"
          render={(record) => getRecipeSpecifications(record)}
        />
        <Column
          title="Action"
          key="action"
          render={(record) => (
            <span>
              <Tooltip title="Voir les détails">
                <Button type="link" icon={<EyeOutlined />} onClick={() => showDeTails(record.id)} />
              </Tooltip>
              {/* <Tooltip title="Modifier la recette"> */}
              {/*  <Button type="link" icon={<EditOutlined />} onClick={() => handleEditRecipe(record.id)} /> */}
              {/* </Tooltip> */}
              <Divider type="vertical" />
              <Tooltip title="Générer un cahier des charges à partir de cette recette">
                <Button type="link" icon={<BuildOutlined />} onClick={() => handleGenerateSpecification(record)} />
              </Tooltip>
              <Divider type="vertical" />
              <Tooltip title="Supprimer cette recette">
                {/* eslint-disable-next-line no-underscore-dangle */}
                <Button type="link" icon={<DeleteOutlined />} onClick={() => deleteSelectedRecipe(record.id, record._version)} />
              </Tooltip>
            </span>
          )}
        />
      </Table>
    </TableWrapper>
  );
};

RecipesTable.propTypes = {
  recipes: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    userId: PropTypes.string,
    ingredient: PropTypes.shape({
      condition: PropTypes.string,
      ingredient: PropTypes.string,
      themes: PropTypes.string
    })
  })),
  history: PropTypes.shape({
    replace: PropTypes.func,
    push: PropTypes.func,
  }),
  deleteSelectedRecipe: PropTypes.func,
  handleGenerateSpecification: PropTypes.func
};

export default RecipesTable;
